import React from "react";

const Footer = () => (
  <div className="bg-info footer">
    <p className="footnote">Created by Nettles</p>
    <p className="footnote">&copy; Persevere 2020</p>
  </div>
);

export default Footer;
